import { render } from "./ProductSalesWithStock.vue?vue&type=template&id=013aacda&scoped=true"
import script from "./ProductSalesWithStock.vue?vue&type=script&lang=js"
export * from "./ProductSalesWithStock.vue?vue&type=script&lang=js"

import "./ProductSalesWithStock.vue?vue&type=style&index=0&id=013aacda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013aacda"]])

export default __exports__